import { TWebsiteBuilderDevice } from "./device";
import type { TWebsiteBuilderSectionEntityType } from "../../nodes/websiteBuilderSectionEntity";

export type TWebsiteBuilderCSSVariable = `--wb-${string}`;

export const WB_SCALE_FACTOR_CSS_VARIABLE: TWebsiteBuilderCSSVariable = "--wb-scale-factor";

export const WB_SECTION_HEIGHT_DESKTOP_CSS_VARIABLE: TWebsiteBuilderCSSVariable = "--wb-section-height-desktop";
export const WB_SECTION_HEIGHT_TABLET_CSS_VARIABLE: TWebsiteBuilderCSSVariable = "--wb-section-height-tablet";
export const WB_SECTION_HEIGHT_MOBILE_CSS_VARIABLE: TWebsiteBuilderCSSVariable = "--wb-section-height-mobile";
export const WB_SECTION_PARALLAX_SHIFT_CSS_VARIABLE: TWebsiteBuilderCSSVariable = "--wb-section-parallax-shift";
export const WB_SECTION_PARALLAX_TRAVEL_CSS_VARIABLE: TWebsiteBuilderCSSVariable = "--wb-section-parallax-travel";

type TWebsiteBuilderSectionEntityCssVariableProperty = "left" | "top" | "width" | "height" | "padding";

export function websiteBuilderGetSectionEntityCssVariable(
  type: TWebsiteBuilderSectionEntityType,
  property: TWebsiteBuilderSectionEntityCssVariableProperty,
  device: TWebsiteBuilderDevice,
): TWebsiteBuilderCSSVariable {
  return `--wb-${type}-${property}-${device}`;
}

export const WB_BUTTON_FONT_SIZE_DESKTOP_CSS_VARIABLE: TWebsiteBuilderCSSVariable = "--wb-button-font-size-desktop";
export const WB_BUTTON_FONT_SIZE_TABLET_CSS_VARIABLE: TWebsiteBuilderCSSVariable = "--wb-button-font-size-tablet";
export const WB_BUTTON_FONT_SIZE_MOBILE_CSS_VARIABLE: TWebsiteBuilderCSSVariable = "--wb-button-font-size-mobile";

export const WB_BUTTON_COLOR_CSS_VARIABLE: TWebsiteBuilderCSSVariable = "--wb-button-color";
export const WB_BUTTON_BACKGROUND_COLOR_CSS_VARIABLE: TWebsiteBuilderCSSVariable = "--wb-button-background-color";
export const WB_BUTTON_BORDER_COLOR_CSS_VARIABLE: TWebsiteBuilderCSSVariable = "--wb-button-border-color";
export const WB_BUTTON_HOVER_COLOR_CSS_VARIABLE: TWebsiteBuilderCSSVariable = "--wb-button-hover-color";
export const WB_BUTTON_HOVER_BACKGROUND_COLOR_CSS_VARIABLE: TWebsiteBuilderCSSVariable = "--wb-button-hover-background-color";
export const WB_BUTTON_HOVER_BORDER_COLOR_CSS_VARIABLE: TWebsiteBuilderCSSVariable = "--wb-button-hover-border-color";

export const WB_LINK_COLOR_CSS_VARIABLE: TWebsiteBuilderCSSVariable = "--wb-link-color";
export const WB_LINK_HOVER_COLOR_CSS_VARIABLE: TWebsiteBuilderCSSVariable = "--wb-link-hover-color";

export const WB_BOX_BACKGROUND_COLOR_CSS_VARIABLE: TWebsiteBuilderCSSVariable = "--wb-box-background-color";
export const WB_BOX_HOVER_BACKGROUND_COLOR_CSS_VARIABLE: TWebsiteBuilderCSSVariable = "--wb-box-hover-background-color";

export const WB_IMAGE_HOVER_OVERLAY_COLOR_CSS_VARIABLE: TWebsiteBuilderCSSVariable = "--wb-image-hover-overlay-color";
export const WB_IMAGE_HOVER_OVERLAY_OPACITY_CSS_VARIABLE: TWebsiteBuilderCSSVariable = "--wb-image-hover-overlay-opacity";
export const WB_IMAGE_HOVER_SCALE_CSS_VARIABLE: TWebsiteBuilderCSSVariable = "--wb-image-hover-scale";

export const WB_RICH_TEXT_FONT_SIZE_DESKTOP_CSS_VARIABLE: TWebsiteBuilderCSSVariable = "--wb-rich-text-font-size-desktop";
export const WB_RICH_TEXT_FONT_SIZE_TABLET_CSS_VARIABLE: TWebsiteBuilderCSSVariable = "--wb-rich-text-font-size-tablet";
export const WB_RICH_TEXT_FONT_SIZE_MOBILE_CSS_VARIABLE: TWebsiteBuilderCSSVariable = "--wb-rich-text-font-size-mobile";

export const WB_MARQUEE_FONT_SIZE_DESKTOP_CSS_VARIABLE: TWebsiteBuilderCSSVariable = "--wb-marquee-font-size-desktop";
export const WB_MARQUEE_FONT_SIZE_TABLET_CSS_VARIABLE: TWebsiteBuilderCSSVariable = "--wb-marquee-font-size-tablet";
export const WB_MARQUEE_FONT_SIZE_MOBILE_CSS_VARIABLE: TWebsiteBuilderCSSVariable = "--wb-marquee-font-size-mobile";
export const WB_MARQUEE_ANIMATION_DURATION_CSS_VARIABLE: TWebsiteBuilderCSSVariable = "--wb-marquee-animation-duration";

export const WB_GRID_ROWS_CSS_VARIABLE: TWebsiteBuilderCSSVariable = "--wb-grid-rows";
export const WB_GRID_COLUMNS_CSS_VARIABLE: TWebsiteBuilderCSSVariable = "--wb-grid-columns";